export const meta = {
  title: '可接受使用政策 | gridcraft',
  description: '使用 gridcraft 指南、下载资源、网站工具与支持渠道的行为规则。',
  updated_at: '2026-10-18',
};

## 目的

本政策适用于 gridcraft（gridcraft.me）的下载资源、安装指南、Excel 功能对比、使用体验、网站工具及支持渠道，是[《服务条款》](/zh/terms-of-service)的组成部分。

## 允许的使用

您可以出于合法目的浏览指南、访问下载链接、对比软件、体验开放的工具及联系支持。请遵守软件的适用许可，并仅处理您有权访问的数据。

## 禁止的行为

请勿利用网站或支持渠道进行以下活动：

- 传播恶意软件、恶意电子表格、钓鱼链接或欺骗性安装程序。
- 分享盗版软件、盗用的许可密钥，或旨在绕过软件许可限制的操作说明。
- 尝试未经授权访问账户、服务器、私人文件或其他用户的信息。
- 通过过量自动请求、拒绝服务攻击或规避访问限制等方式干扰网站运行。
- 提交垃圾信息、威胁、骚扰、违法内容，或未经授权披露他人隐私。
- 侵犯著作权、商标权、隐私权或其他权利，包括未经授权批量转载本站文章。
- 冒充 gridcraft、ArtCraft、Microsoft 或其他主体，或虚假宣称获得官方背书。

## 文件与支持请求

仅提交您有权分享的文件和截图。请先移除商业机密、个人信息、密码及许可密钥。请勿通过附件发送可疑可执行程序或带有活动恶意内容的工作簿；请先描述问题并提供相关页面链接。

## 自动化访问与安全研究

自动访问应保持合理频率，并遵守已公布的访问限制。请勿绕过身份验证或技术防护。如果发现潜在漏洞，请私下报告，不要访问他人数据或干扰网站服务。

## 问题举报

请发送邮件至 [support@gridcraft.me](mailto:support@gridcraft.me)，附上页面链接、问题说明和可安全分享的佐证。您可以举报失效或可疑下载链接、不准确的对比内容、版权问题、滥用内容或疑似安全问题。首次报告请勿包含攻击载荷或敏感数据。

## 处理与复核

我们可能调查举报、纠正或移除内容、限制请求，或在处理滥用行为所需的情况下限制访问及账户。在适用法律要求时，我们可能配合有关部门。如果您认为处理有误，请通过支持邮箱提供足够的信息，以便我们复核。

## 更新与联系

我们可能随网站功能变化修订本政策，最新修订日期见页首。相关问题：[support@gridcraft.me](mailto:support@gridcraft.me)。
